var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "panel" },
      [
        _vm._l(_vm.countdownTimers, function(timer, index) {
          return _c(
            "div",
            { key: index, staticClass: "panel-section" },
            [
              _c("countdown-timer", {
                attrs: {
                  "start-date-string": timer.NotificationStartDate,
                  "target-date-string": timer.EventStartDate,
                  "header-text": timer.TitleDescription,
                  "footer-text": timer.CTA,
                  "target-url":
                    timer.EventUrl && timer.EventUrl.Url
                      ? timer.EventUrl.Url
                      : null,
                  BackgroundImage: timer.BackgroundImage,
                  "timer-text-color": timer.TimerTextColor,
                  "timer-background-color": timer.TimerBackgroundColor,
                  logo: timer.Logo,
                  "footer-color": timer.FooterBackgroundColor
                }
              })
            ],
            1
          )
        }),
        _vm._v(" "),
        _c("div", { staticClass: "panel-section" }, [_c("popular-apps")], 1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "panel-section" },
          [_c("my-content", { ref: "myContent" })],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "panel-section" }, [_c("bookmarks")], 1),
        _vm._v(" "),
        _c("div", { staticClass: "panel-section" }, [_c("events")], 1)
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07cbd747", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07cbd747","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/RightPanel.vue
// module id = null
// module chunks = 